<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb name="Details" :breadcrumb="breadcrumb"/>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <Form class="form form-horizontal" v-slot="{ meta,errors  }" @submit="sendCall"
                        :initial-values="{expiresIndays: '',expiresInhours : '',expiresInminutes : '',callbackUrl : ''}" ref="myForm">
                    <div class="row">

                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Currency</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group input-group-merge">
                              <Field as="select" rules="required" name="currency" class="form-control"
                                     :class="(errors.type && !meta.valid && meta.touched)? 'is-invalid': ''"
                                     @input="currencyChange">
                                <option value>Select Currency</option>
                                <option :key="currencyIndex" :value="currency.id"
                                        v-for="(currency, currencyIndex) in currencyData">
                                  {{ currency.code }}
                                </option>
                              </Field>
                              <div class="input-group-append" v-if="currencyLoader">
                                <span class="input-group-text cursor-pointer"><div
                                    class="spinner-border text-primary spinner-border-sm"></div></span>
                              </div>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="currency"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Channel</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group input-group-merge">
                              <Field as="select" rules="required" name="channelId" class="form-control"  @input="channelChange">
                                <option :key="channelIndex" :value="channel.id"
                                        v-for="(channel, channelIndex) in channelData" >
                                  {{ resolveChannelName(channel) }}
                                </option>
                              </Field>
                              <div class="input-group-append" v-if="channelLoader">
                                <span class="input-group-text cursor-pointer"><div
                                    class="spinner-border text-primary spinner-border-sm"></div></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Schema</label>
                          </div>
                          <div class="col-sm-9">
                            <Multiselect
                                v-model="paymentMethodIds"
                                placeholder="Select Schemas"
                                mode="tags"
                                :loading="paymentMethodLoader"
                                :createTag="true"
                                :options="multiselectOptionToShow"
                                ref="multiselect"
                                name="schema"
                            />
                            <small role="alert" class="text-danger" v-show="schemaField">The Schema field is required</small>
                          </div>

                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Amount</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field
                                  class="form-control"
                                  type="text"
                                  name="amount"
                                  rules="required|decAmount"
                                  :class="(errors.amount && !meta.valid && meta.touched)? 'is-invalid': ''"
                              >
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="amount"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <Field as="select" rules="required" name="type" class="form-control"
                                     :class="(errors.type && !meta.valid && meta.touched)? 'is-invalid': ''">
                                <option value>Select Type</option>
                                <option value="single">Single</option>
                                <option value="multiple">Multiple</option>
                              </Field>
                            </div>
                            <ErrorMessage as="small" class="text-danger" name="type"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Expires In</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="row ">
                              <div class="col-4">
                                <label>Days</label>
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="expiresIndays"

                                />
                                <ErrorMessage name="expiresIndays"/>
                              </div>
                              <div class="col-4">
                                <label>Hours</label>
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="expiresInhours"

                                />
                                <ErrorMessage name="expiresInhours"/>
                              </div>
                              <div class="col-4">
                                <label>Minutes</label>
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="expiresInminutes"

                                />
                                <ErrorMessage name="expiresInminutes"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12" v-if="advanceSettings">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Redirect URL (Optional)</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="redirectUrl"
                                    :class="(errors.callbackUrl && !meta.valid && meta.touched)? 'is-invalid': ''"
                                >
                                </Field>
                              </div>
                              <ErrorMessage as="small" class="text-danger" name="redirectUrl"/>
                            </div>
                          </div>
                        </div>
                      <div class="col-12" v-if="advanceSettings">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>CallBack URL (Optional)</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="callbackUrl"
                                    :class="(errors.callbackUrl && !meta.valid && meta.touched)? 'is-invalid': ''"
                                >
                                </Field>
                              </div>
                              <ErrorMessage as="small" class="text-danger" name="callbackUrl"/>
                            </div>
                          </div>
                        </div>
                      <div class="col-12" v-if="advanceSettings">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Receipt No (Optional)</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="receiptNo"
                                    :class="(errors.callbackUrl && !meta.valid && meta.touched)? 'is-invalid': ''"
                                >
                                </Field>
                              </div>
                              <ErrorMessage as="small" class="text-danger" name="receiptNo"/>
                            </div>
                          </div>
                        </div>
                      <div class="col-12" v-if="advanceSettings">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Email (Optional)</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="email"
                                    :class="(errors.callbackUrl && !meta.valid && meta.touched)? 'is-invalid': ''"
                                >
                                </Field>
                              </div>
                              <ErrorMessage as="small" class="text-danger" name="email"/>
                            </div>
                          </div>
                        </div>
                      <div class="col-12" v-if="advanceSettings">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Phone (Optional)</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <Field
                                    class="form-control"
                                    type="text"
                                    name="phone"
                                    :class="(errors.callbackUrl && !meta.valid && meta.touched)? 'is-invalid': ''"
                                >
                                </Field>
                              </div>
                              <ErrorMessage as="small" class="text-danger" name="phone"/>
                            </div>
                          </div>
                        </div>
                      <div class="col-12" v-if="advanceSettings">
                          <div class="form-group row">
                            <div class="col-sm-3 col-form-label">
                              <label>Description</label>
                            </div>
                            <div class="col-sm-9">
                              <div class="input-group">
                                <Field
                                    class="form-control"
                                    name="description"
                                    as="textarea"
                                    rows="3"
                                    placeholder="Type description here........"
                                >
                                </Field>
                              </div>
                            </div>
                          </div>
                        </div>
                      <div class="col-sm-9 offset-sm-3">
                        <button
                            type="button"
                            class="btn btn-warning btn-sm float-right"
                            @click="advanceSettings = !advanceSettings"
                        >
                          Advance Settings
                        </button>
                      </div>
                      <div class="col-sm-9 offset-sm-3">
                        <Button class="btn btn-primary mr-1" :loading="loader">Save</Button>
                        <button
                            type="button"
                            class="btn btn-gradient-secondary"
                            @click="$router.push({ name: 'payment-link' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Multiselect from '@vueform/multiselect'
import Button from "@/components/common/Button";

export default {
  components: {Button, Multiselect},
  mounted() {
    this.getCurrencyData()






  },
  data() {
    return {
      breadcrumb: [
        {name: 'App'},
        {name: 'Payment Link'},
        {name: 'Add'},
      ],
      loader: false,
      schemaField: false,
      currencyLoader: true,
      channelLoader: true,
      paymentMethodLoader: true,
      emailOrPhone: '',
      selectedCurrency: null,
      currencyData: [],
      paymentMethodIds: null,
      multiselectOptionToShow: {},
      channelData:[],
      selectedChannel:'',
      advanceSettings:false,


    }
  },
  methods: {
    resolveChannelName(obj){
      let name = ''
      if(obj.store){
        name+= obj.store.name+'/'
      }
      if(obj.terminal){
        name+= obj.terminal.name+'/'
      }

      name+= obj.name

      return name

    },
    currencyChange(event) {
      this.$refs.multiselect.clear()
      // event.target.value is currencyID
      // this.getPaymentMethodData(event.target.value)
      this.selectedCurrency = event.target.value
      this.getPaymentMethodData()
    },
    channelChange(event) {
      this.$refs.multiselect.clear()
      this.selectedChannel = event.target.value
      this.getPaymentMethodData()
    },
    sendCall(values) {
      if(this.isEmpty(this.paymentMethodIds)){
        this.schemaField = true
        return
      }
      let data = values
      data.currencyId = data.currency;
      data.amount = data.amount * 100
      data.schemaIds = this.paymentMethodIds
      delete data.currency
      this.loader = true
      this.makeRequest('post', 'v1/add-new-payment-link', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.push({name: 'payment-link'});
          } else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
          this.$refs.myForm.setFieldValue('amount', '')
        }
        this.$refs.myForm.setFieldValue('amount', '')

      });

    },
    getCurrencyData() {

      this.makeRequest('post', 'v1/get-allowed-currencies', {type: 'PAYMENT_LINK'}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.currencyData = responseData
            this.selectedCurrency = responseData[0].id
            this.getChannelData()



          }
        }

        this.currencyLoader = false

      });
    },
    getChannelData() {
      this.makeRequest('post', 'v1/get-stores', {type:1}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.channelData = responseData.channels
            if(this.channelData){
              this.$refs.myForm.setFieldValue('channelId', responseData.channels[0].id);
              this.selectedChannel = responseData.channels[0].id
              this.getPaymentMethodData()
            }

          }
          this.channelLoader = false
        }


      });
    },
    getPaymentMethodData() {
      this.paymentMethodLoader = true
      this.makeRequest('post', 'v1/get-allowed-payment-methods', {
        currencyId: this.selectedCurrency,
        channelId: this.selectedChannel,
        type: 'PAYMENT_LINK'
      }, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.multiselectOptionToShow = {}
            if(responseData){
              responseData.forEach((obj) => {
                this.multiselectOptionToShow[obj.id] = obj.name
              })
            }

          }
        }

        this.paymentMethodLoader = false

      });
    },
  },
  watch: {
    paymentMethodIds(val){
      if(this.isEmpty(val)){
        this.schemaField = true
      }
      else{
        this.schemaField = false
      }
    }
  }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>

